import { Box, Skeleton } from '@mui/material';
import { WalletSummaryCard } from 'src/pages/Monitor/components/WalletSummaryCard';
import { CompositionDataItem, Wallet } from 'src/types/wallet';

import { CompositionCard } from '../CompositionCard';

type InfoCardsProps = {
  wallet: Wallet | null | undefined;
  isLoadingWallet: boolean;
  handleOpenCompositionModal: () => void;
  compositionData: CompositionDataItem[];
  countTotalQuotas: number;
  showAlertSummary?: boolean;
  walletWarningSummary: {
    alertCount: number;
    criticalCount: number;
    walletSummaryCount: number;
  };
};

export function InfoCards({
  wallet,
  isLoadingWallet,
  handleOpenCompositionModal,
  compositionData,
  countTotalQuotas,
  showAlertSummary = false,
  walletWarningSummary,
}: InfoCardsProps) {
  return isLoadingWallet ? (
    <Box
      width="100%"
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      gap={2}
      px={3}
      pb={2}>
      <Skeleton
        variant="rectangular"
        animation="wave"
        width="100%"
        height={140}
        sx={{ borderRadius: 2 }}
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        width="100%"
        height={140}
        sx={{ borderRadius: 2 }}
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        width="100%"
        height={140}
        sx={{ borderRadius: 2 }}
      />
    </Box>
  ) : (
    <Box
      width="100%"
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={2}
      px={1}
      pb={2}>
      <CompositionCard
        title="Composição"
        compositions={compositionData}
        onClick={handleOpenCompositionModal}
      />
      <WalletSummaryCard
        data={{
          title: 'Total de Fundos',
          description: 'monitorados',
          value: countTotalQuotas,
        }}
      />
      {wallet && (wallet.isSharedWallet === false || showAlertSummary) && (
        <WalletSummaryCard
          data={{
            title: 'Atenção necessária',
            description: 'alerta(s) disparado(s)',
            value: walletWarningSummary.walletSummaryCount,
            ...(walletWarningSummary.walletSummaryCount > 0
              ? { color: '#ff4747' }
              : {}),
          }}
        />
      )}
    </Box>
  );
}
